import { initializePermissionApi, PermissionApi } from '@data-delivery/permission-ui-api';
import { queryOptions } from '@tanstack/react-query';

const productsApi = initializePermissionApi(PermissionApi.ProductsApi);

export const productsKeys = {
  all: () => ['products'] as const,
  list: () => [...productsKeys.all(), 'list'] as const,
  byId: (id: string) => [...productsKeys.all(), 'by-id', id] as const,
  searchByName: (name: string) => [...productsKeys.all(), 'search-name', name] as const,
};

export const productsQueries = {
  list: () =>
    queryOptions({
      queryKey: productsKeys.list(),
      async queryFn() {
        const { data } = await productsApi.getProducts();
        return data ?? [];
      },
      staleTime: 60_000,
    }),
  byId: (id: string) =>
    queryOptions({
      queryKey: productsKeys.byId(id),
      enabled: Boolean(id),
      async queryFn() {
        const { data } = await productsApi.getProductById({ id });
        return data ?? null;
      },
    }),
  searchByName: (name: string) =>
    queryOptions({
      queryKey: productsKeys.searchByName(name),
      enabled: Boolean(name) && name.trim().length > 0,
      async queryFn() {
        const { data } = await productsApi.searchProductByName({ search: name });
        return data ?? [];
      },
    }),
};

export type ProductEntity = PermissionApi.ProductEntity;
